import { useMemo } from "react";
import { IStormDoorHandleListing } from "../../../../entities-generated/models/storm-door/storm-door-handle-listing";
import { toDateTimeString } from "../../../../framework/utils/date-time";
import { BwjListing } from "../../../../framework/components/bwj-listing";
import { BadgeType } from "../../../../framework/components/bwj-listing/entities";

interface IStormHandleListItemProps {
  handle: IStormDoorHandleListing;
  onClick: (handle: IStormDoorHandleListing) => void;
}

export const StormHandleListItem: React.FunctionComponent<IStormHandleListItemProps> = (props) => {
  const { handle } = props;
  const availability = handle.inactive ? 'Inactive'
    : handle.unavailable ? 'Unavailable' : 'Active';
  const subtext = useMemo(() => {
    const st: string[] = [`@ ${handle.vendor}`];
    if(!!handle.lastModified) {
      st.push(`last modified ${toDateTimeString(handle.lastModified)}`);
    }
    return st.join('; ');
  }, [handle]);

  return (
    <BwjListing
      heading={`${handle.brand} ${handle.description}`}
      badge={{
        type: BadgeType.Image,
        content: handle.imageUrl,
      }}
      loadImage={true}
      secondaryLine={availability}
      footnote={subtext}
      data={handle}
      onClick={props.onClick}
    />
  );
};